import { render, staticRenderFns } from "./CulturalPublications.vue?vue&type=template&id=f6c387d8&"
import script from "./CulturalPublications.vue?vue&type=script&lang=js&"
export * from "./CulturalPublications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports